import api from "@/application";
import {
  SET_PREVIEW,
  SET_LAST_SELECTED_ENTITY_TYPES,
  SET_LOADING,
  SET_ERROR,
  SET_BITRIX_AUTH,
  SET_IS_BITRIX,
  SET_BITRIX_LINKED,
  SET_BITRIX_CONNECTION_VALID,
} from "./mutation-types";
import { RESET } from "../../mutation-types";

const actions = {
  getBitrixExportPreview: async ({ commit, rootGetters }, lotIds) => {
    commit(SET_LOADING, true);
    commit(SET_ERROR, null);

    try {
      const email =
        rootGetters["impersonalization/mindControlledUser"] ||
        rootGetters["auth/email"];
      const { data } = await api.bitrix.getPreview(lotIds, email);
      commit(SET_PREVIEW, data.proposals);
      commit(SET_LAST_SELECTED_ENTITY_TYPES, data.lastSelectedEntityTypes);
    } catch (e) {
      commit(SET_ERROR, e?.response?.status || "UNKNOWN");

      throw e;
    } finally {
      commit(SET_LOADING, false);
    }
  },

  sendToBitrix: async ({ commit, rootGetters }, payload) => {
    commit(SET_LOADING, true);
    commit(SET_ERROR, null);

    try {
      const email =
        rootGetters["impersonalization/mindControlledUser"] ||
        rootGetters["auth/email"];
      const res = await api.bitrix.send(payload, email);
      return res;
    } catch (e) {
      commit(SET_ERROR, e?.response?.status || "UNKNOWN");
      throw e;
    } finally {
      commit(SET_LOADING, false);
    }
  },
  resetBitrixExportState: ({ commit }) => {
    commit(RESET);
  },
  linkBitrix: async ({ commit }, payload) => {
    commit(SET_LOADING, true);
    commit(SET_ERROR, null);

    try {
      const res = await api.bitrix.link(payload);
      commit(SET_BITRIX_LINKED, true);
      return res;
    } catch (e) {
      commit(SET_ERROR, e?.response?.status || "UNKNOWN");
      throw e;
    } finally {
      commit(SET_LOADING, false);
    }
  },
  initBitrix: ({ commit, state }) => {
    if (state.isBitrix) {
      return;
    }

    if (!window.BX24) {
      commit(SET_IS_BITRIX, false);
      return;
    }

    window.BX24.init(() => {
      const auth = window.BX24.getAuth();
      commit(SET_BITRIX_AUTH, auth);
      commit(SET_IS_BITRIX, true);
      console.log("Bitrix AUTH:", auth);
    });
  },

  getBitrixMapping: async ({ commit }, memberId) => {
    commit(SET_ERROR, null);

    try {
      const { data } = await api.bitrix.getMapping(memberId);

      return data;
    } catch (e) {
      commit(SET_ERROR, e?.response?.status || "UNKNOWN");

      throw e;
    }
  },

  updateBitrixMapping: async ({ commit }, { memberId, payload }) => {
    commit(SET_ERROR, null);

    try {
      const { data } = await api.bitrix.updateMapping(memberId, payload);

      return data;
    } catch (e) {
      commit(SET_ERROR, e?.response?.status || "UNKNOWN");
      throw e;
    }
  },

  checkConnection: async ({ commit }, memberId) => {
    commit(SET_ERROR, null);

    try {
      const { data } = await api.bitrix.checkConnection(memberId);
      commit(SET_BITRIX_CONNECTION_VALID, data.connected);
      return data;
    } catch (e) {
      commit(SET_ERROR, e?.response?.status || "UNKNOWN");
      commit(SET_BITRIX_CONNECTION_VALID, false);
      throw e;
    }
  },
};

export default actions;
